export const initialState = {

    merchantIssues: [], //userDetails
    merchantIssueDetails: [],
    isIssueAdd : "",
    issueDetail : []
    
    
    };
    
    export const IssueReducer = (state = initialState, action) => {
    switch (action.type) {
    
    
    case "GETMERCHANTISSUELIST":
    return {
    ...state,
    merchantIssues: action.payload.data.data,
    };
    case "GETMERCHANTISSUEDETAILS":
    return {
    ...state,
    merchantIssueDetails: action.payload.data.data,
    };
    case "ADDISSUE":
    return{
    ...state,
    isIssueAdd: action.payload.data.message,
    };
    case "UPDATEISSUE":
    return{
    ...state,
    isIssueAdd: action.payload.data.data,
    }
    default:
    return state;
    }
    };